import { Subject } from 'rxjs';
import { ServerModel } from './types';

export const modelSubject = new Subject<{
  action: 'reload';
  payload: ServerModel;
}>();
